<header id="headadmin">
    <app-header></app-header>
    <app-navbar></app-navbar>
</header>
  <body>
    <div class="card">
      <div class="card-header text-center" style="background-color: #be0c4d;">
        <h5 style="color: white;">Analisis Información - Cartera Hipotecaria Vivienda</h5>
      </div>
      <div class="card-body">
        <div class="row" style="margin-top: 3px;">
          <div class="col-auto" style="text-align: center;">
            <button type="button" class="btn btn-secondary" (click)="regresarAnalisis()">Volver</button>
          </div>
          <div class="col-1" style="text-align: center;">
            <label style="margin-top: 4px;"><b>Periodo :</b></label>
          </div>
          <div class="col-auto">
            <select class="form-select" aria-label="Default select example" name="anio" (change)="CosultarListaEstados()" [(ngModel)]="anioConsulta"><!--     [disabled]="btnGuardar"-->
              <option  value="PeriodoSeleccionado.anio" selected="selected">Seleccionar</option>
              <option *ngFor="let p of aniosVigen" value="{{p}}">{{p}}</option>
            </select>
          </div>
          <div class="col-auto">
            <label for=""><b>-</b></label>
          </div>
          <div class="col-auto">
            <select class="form-select" aria-label="Default select example" name="trimestre" (change)="CosultarListaEstados()" [(ngModel)]="consucutivoConsulta" ><!-- [(ngModel)]="PeriodoConsulta"   [disabled]="btnGuardar"-->
              <option value="" selected="selected">Seleccionar</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </select>
          </div>
        </div>
        <br>
        <div class="row" style="margin-top: 8px; margin-left: 0px;">
          <button type="button" class="btn btn-secondary col-auto" (click)="FichaGeneralAnalisis()">Ver ficha analisis general</button>
        </div>
        <div id="tabla" class="container-fluid overflow-scroll">
          <table datatable [dtOptions]="dtOptions"  [dtTrigger]="dtTrigger" class="table table-bordered row-border hover datatable"
             id="table2excel">
            <thead>
              <tr>
                <th scope="col" class="text-center">Periodo</th>
                <th scope="col" class="text-center">NIT</th>
                <th scope="col" class="text-center">Razón social</th>
                <th scope="col" class="text-center">Departamento</th>
                <th scope="col" class="text-center">Municipio</th>
                <th scope="col" class="text-center">Estado fuente</th>
                <th scope="col" class="text-center">Novedad</th>
                <th scope="col" class="text-center">Verificar</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let L of ListaEstadosFuentes">
                <td scope="col" >{{L.perido}}</td>
                <td scope="col" >{{L.nit}}</td>
                <td scope="col" >{{L.razonSocial}}</td>
                <td scope="col" >{{L.depto}}</td>
                <td scope="col" >{{L.muni}}</td>
                <td scope="col" >{{L.estado}}</td>
                <td scope="col" >{{L.novedad}}</td>
                <td scope="col" class="text-center" id="opciones">
                  <a *ngIf="L.estado=='Cargado'" type="button" class="fa fa-chevron-circle-right" style="color: green; margin: 2px;" (click)="FichaIndividualAnalisis(L.idfuente)"></a>
                  <a *ngIf="L.estado=='Aprobado'" type="button" class="fa fa-chevron-circle-right" style="color: blue; margin: 2px;" (click)="FichaIndividualAnalisis(L.idfuente)"></a>
                  <a *ngIf="L.estado=='Pendiente'||L.estado=='En cargue'||L.estado=='En Proceso'" type="button" class="fa fa-chevron-circle-right" style="color: gray;  margin: 2px;  margin: 2px;"></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </body>

<!--FICHA DE ANALISIS GENERAL-->
<button class="btn btn-primary btn-sm" #OpenModalFichaGeneral data-toggle="modal"  data-target="#fichageneral" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-fullscreen" id="fichageneral" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 style="color: white;">FICHA ANALISIS INFORMACION - GENERAL</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row" style="margin: 5px;">
            <div class="col-2">
              <div class="row"><b>Periodo</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="periodo" [(ngModel)]="PeriodoFichaGeneral" disabled/></div>
            </div>
          </div>
          <button type="button" class="btn btn-success col-1" style="text-align: center; margin: 10px;" (click)="exportarExcelv2()"><i class="fas fa-download"></i> Excel</button>
          <br>
          <nav id="FichaGeneralAnalisis">
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <button class="nav-link active" id="nav-salcapto-tab" data-bs-toggle="tab" data-bs-target="#nav-salcapto" type="button" role="tab" aria-controls="nav-salcapto" aria-selected="true" ><!--(click)="saldocaptotalgeneral()"-->
                <b style="color: black;">Saldo Capital Total</b>
              </button>
              <button class="nav-link" id="nav-salven-tab" data-bs-toggle="tab" data-bs-target="#nav-salven" type="button" role="tab" aria-controls="nav-salven" aria-selected="false" ><!--(click)="saldovencidogeneral()"-->
                <b style="color: black;">Saldo Vencido</b>
              </button>
              <button class="nav-link" id="nav-numcred-tab" data-bs-toggle="tab" data-bs-target="#nav-numcred" type="button" role="tab" aria-controls="nav-numcred" aria-selected="false" ><!--(click)="numerocreditosgeneral()"-->
                <b style="color: black;">Número Créditos</b>
              </button>
              <button class="nav-link" id="nav-deptos-tab" data-bs-toggle="tab" data-bs-target="#nav-deptos" type="button" role="tab" aria-controls="nav-deptos" aria-selected="false" ><!--(click)="departamentosgeneral()"-->
                <b style="color: black;">Departamentos</b>
              </button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-salcapto" role="tabpanel" aria-labelledby="nav-salcapto-tab">
              <div class="accordion accordion-flush" id="accordionFlush1">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo13sct">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo13sct" aria-expanded="false" aria-controls="flush-tipo13sct">
                      1. TIPO CREDITO OPCION 1 Y 3
                    </button>
                  </h2>
                  <div id="flush-tipo13sct" class="accordion-collapse collapse show" aria-labelledby="flush-tipo13sct" data-bs-parent="#accordionFlush1">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaSaldoCapitalTotalTipoCred13" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila1 of TablaTipCred13SCTG">
                              <td scope="col" style="text-align: end;" >{{Fila1.concepto}}</td>
                              <td scope="col">{{Fila1.trimestreanterior  | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila1.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila1.variaciontrimestre}}</td>
                              <td scope="col">{{Fila1.anioanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila1.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila1.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo1sct">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo1sct" aria-expanded="false" aria-controls="flush-tipo1sct">
                      2. TIPO CREDITO OPCION 1
                    </button>
                  </h2>
                  <div id="flush-tipo1sct" class="accordion-collapse collapse" aria-labelledby="flush-tipo1sct" data-bs-parent="#accordionFlush1">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaSaldoCapitalTotalTipoCred1" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila2 of TablaTipCred1SCTG">
                              <td scope="col" style="text-align: end;">{{Fila2.concepto}}</td>
                              <td scope="col">{{Fila2.trimestreanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila2.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila2.variaciontrimestre}}</td>
                              <td scope="col">{{Fila2.anioanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila2.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila2.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo3sct">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo3sct" aria-expanded="false" aria-controls="flush-tipo3sct">
                      3. TIPO CREDITO OPCION 3
                    </button>
                  </h2>
                  <div id="flush-tipo3sct" class="accordion-collapse collapse" aria-labelledby="flush-tipo3sct" data-bs-parent="#accordionFlush1">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaSaldoCapitalTotalTipoCred3" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila3 of TablaTipCred3SCTG">
                              <td scope="col" style="text-align: end;">{{Fila3.concepto}}</td>
                              <td scope="col">{{Fila3.trimestreanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila3.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila3.variaciontrimestre}}</td>
                              <td scope="col">{{Fila3.anioanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila3.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila3.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="nav-salven" role="tabpanel" aria-labelledby="nav-salven-tab">
              <div class="accordion accordion-flush" id="accordionFlush2">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo13sv">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo13sv" aria-expanded="false" aria-controls="flush-tipo13sv">
                      1. TIPO CREDITO OPCION 1 Y 3
                    </button>
                  </h2>
                  <div id="flush-tipo13sv" class="accordion-collapse collapse show" aria-labelledby="flush-tipo13sv" data-bs-parent="#accordionFlush2">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaSaldoVencidoTipoCred13" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila4 of TablaTipCred13SVG">
                              <td scope="col" style="text-align: end;">{{Fila4.concepto}}</td>
                              <td scope="col">{{Fila4.trimestreanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila4.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila4.variaciontrimestre}}</td>
                              <td scope="col">{{Fila4.anioanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila4.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila4.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo1sv">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo1sv" aria-expanded="false" aria-controls="flush-tipo1sv">
                      2. TIPO CREDITO OPCION 1
                    </button>
                  </h2>
                  <div id="flush-tipo1sv" class="accordion-collapse collapse" aria-labelledby="flush-tipo1sv" data-bs-parent="#accordionFlush2">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaSaldoVencidoTipoCred1" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila5 of TablaTipCred1SVG">
                              <td scope="col" style="text-align: end;">{{Fila5.concepto}}</td>
                              <td scope="col">{{Fila5.trimestreanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila5.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila5.variaciontrimestre}}</td>
                              <td scope="col">{{Fila5.anioanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila5.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila5.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo3sv">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo3sv" aria-expanded="false" aria-controls="flush-tipo3sv">
                      3. TIPO CREDITO OPCION 3
                    </button>
                  </h2>
                  <div id="flush-tipo3sv" class="accordion-collapse collapse" aria-labelledby="flush-tipo3sv" data-bs-parent="#accordionFlush2">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaSaldoVencidoTipoCred3" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila6 of TablaTipCred3SVG">
                              <td scope="col" style="text-align: end;">{{Fila6.concepto}}</td>
                              <td scope="col">{{Fila6.trimestreanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila6.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila6.variaciontrimestre}}</td>
                              <td scope="col">{{Fila6.anioanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila6.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila6.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="nav-numcred" role="tabpanel" aria-labelledby="nav-numcred-tab">
              <div class="accordion accordion-flush" id="accordionFlush3">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo13nc">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo13nc" aria-expanded="false" aria-controls="flush-tipo13nc">
                      1. TIPO CREDITO OPCION 1 Y 3
                    </button>
                  </h2>
                  <div id="flush-tipo13nc" class="accordion-collapse collapse show" aria-labelledby="flush-tipo13nc" data-bs-parent="#accordionFlush3">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaNumeroCreditosTipoCred13" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila7 of TablaTipCred13NCG">
                              <td scope="col" style="text-align: end;">{{Fila7.concepto}}</td>
                              <td scope="col">{{Fila7.trimestreanterior}}</td>
                              <td scope="col">{{Fila7.trimestreactual}}</td>
                              <td scope="col">{{Fila7.variaciontrimestre}}</td>
                              <td scope="col">{{Fila7.anioanterior}}</td>
                              <td scope="col">{{Fila7.trimestreactual}}</td>
                              <td scope="col">{{Fila7.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo1nc">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo1nc" aria-expanded="false" aria-controls="flush-tipo1nc">
                      2. TIPO CREDITO OPCION 1
                    </button>
                  </h2>
                  <div id="flush-tipo1nc" class="accordion-collapse collapse" aria-labelledby="flush-tipo1nc" data-bs-parent="#accordionFlush3">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaNumeroCreditosTipoCred1" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila8 of TablaTipCred1NCG">
                              <td scope="col" style="text-align: end;">{{Fila8.concepto}}</td>
                              <td scope="col">{{Fila8.trimestreanterior}}</td>
                              <td scope="col">{{Fila8.trimestreactual}}</td>
                              <td scope="col">{{Fila8.variaciontrimestre}}</td>
                              <td scope="col">{{Fila8.anioanterior}}</td>
                              <td scope="col">{{Fila8.trimestreactual}}</td>
                              <td scope="col">{{Fila8.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo3nc">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo3nc" aria-expanded="false" aria-controls="flush-tipo3nc">
                      3. TIPO CREDITO OPCION 3
                    </button>
                  </h2>
                  <div id="flush-tipo3nc" class="accordion-collapse collapse" aria-labelledby="flush-tipo3nc" data-bs-parent="#accordionFlush3">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaNumeroCreditosTipoCred3" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila9 of TablaTipCred3NCG">
                              <td scope="col" style="text-align: end;">{{Fila9.concepto}}</td>
                              <td scope="col">{{Fila9.trimestreanterior}}</td>
                              <td scope="col">{{Fila9.trimestreactual}}</td>
                              <td scope="col">{{Fila9.variaciontrimestre}}</td>
                              <td scope="col">{{Fila9.anioanterior}}</td>
                              <td scope="col">{{Fila9.trimestreactual}}</td>
                              <td scope="col">{{Fila9.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="nav-deptos" role="tabpanel" aria-labelledby="nav-deptos-tab">
              <div class="accordion accordion-flush" id="accordionFlush4">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo13depto">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo13depto" aria-expanded="false" aria-controls="flush-tipo13depto">
                      1. TIPO CREDITO OPCION 1 Y 3
                    </button>
                  </h2>
                  <div id="flush-tipo13depto" class="accordion-collapse collapse show" aria-labelledby="flush-tipo13depto" data-bs-parent="#accordionFlush4">
                    <div class="accordion-body">
                      <div style="text-align: center;">
                        <div class="container-fluid overflow-scroll" style="max-height: 450px;">
                          <table class="table table-bordered" id="TablaDeapartamentosTipoCred13" style="margin: auto;">
                            <thead style="background-color: lightgray;">
                              <tr>
                                <th scope="col" class="text-center" rowspan="2">Departamento</th>
                                <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                                <th scope="col" class="text-center" colspan="3">Variación anual</th>
                              </tr>
                              <tr>
                                <th class="text-center">{{PeriodoCol1}}</th>
                                <th class="text-center">{{PeriodoCol2}}</th>
                                <th class="text-center">% Variación</th>
                                <th class="text-center">{{PeriodoCol4}}</th>
                                <th class="text-center">{{PeriodoCol5}}</th>
                                <th class="text-center">% Variación</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let Fila10 of TablaTipCred13DG">
                                <td scope="col" style="text-align: end; max-width: 400px;">{{Fila10.concepto}}</td>
                                <td scope="col">{{Fila10.trimestreanterior | currency: 'USD' | lowercase }}</td>
                                <td scope="col">{{Fila10.trimestreactual | currency: 'USD' | lowercase }}</td>
                                <td scope="col">{{Fila10.variaciontrimestre}}</td>
                                <td scope="col">{{Fila10.anioanterior | currency: 'USD' | lowercase }}</td>
                                <td scope="col">{{Fila10.trimestreactual | currency: 'USD' | lowercase }}</td>
                                <td scope="col">{{Fila10.variacionanual}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Salir</button>
      </div>
    </div>
  </div>
</div>

<!--FICHA DE ANALISIS INDIVIDUAL-->
<button class="btn btn-primary btn-sm" #OpenModalFichaIndividual data-toggle="modal"  data-target="#fichaindividial" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-fullscreen" id="fichaindividial" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 style="color: white;">FICHA ANALISIS INFORMACION</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" #CloseModalFichaIndividual>
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row" style="margin: 5px;">
            <div class="col-2">
              <div class="row"><b>Periodo</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="periodofichaind" [(ngModel)]="PeriodoFichaIndividual" disabled/></div>
            </div>
            <div class="col-2">
              <div class="row"><b>NIT</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="nitfichaind" [(ngModel)]="FuenteFichaIndividual.nit" disabled/></div>
            </div>
            <div class="col-4">
              <div class="row"><b>Razón social</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="razonsocialfichaind" [(ngModel)]="FuenteFichaIndividual.nombEntidad" disabled/></div>
            </div>
            <div class="col-4">
              <div class="row"><b>Novedad</b></div>
              <div class="row"><input class="form-control" type="text" name="Novedadfichaind" [(ngModel)]="NovedadFichaIndividual" disabled/></div>
            </div>
          </div>
          <div>
            <div class="row" style="margin: 5px;"><b>Observaciones novedad</b></div>
            <div class="row" style="margin: 5px;"><input class="form-control" type="text" name="Novedad" [(ngModel)]="EstadoInfomacionFuente.observacionFte" disabled/></div>
          </div>
          <div class="row">
            <button type="button" class="btn btn-danger col-auto" style="text-align: center; margin: 10px;" (click)="VerCargue()" [disabled]="CertNoMovi">Ver Cargue</button>
            <button type="button" class="btn btn-danger col-1" style="text-align: center; margin: 10px;" (click)="AprobarCargue()">Aprobar</button>
            <button type="button" class="btn btn-success col-1" style="text-align: center; margin: 10px;" (click)="ExportarExcelFichaAnalisisIndividual()" [disabled]="CertNoMovi"><i class="fas fa-download"></i> Excel</button>
          </div>
          <nav *ngIf="!VercargueFuente&&!AprobarcargueFuente">
            <div class="nav nav-tabs" id="nav-tab-fichaind" role="tablist">
              <button class="nav-link active" id="nav-salcapto-tab-fichaind" data-bs-toggle="tab" data-bs-target="#nav-salcapto-fichaind" type="button" role="tab" aria-controls="nav-salcapto-fichaind" aria-selected="true" [disabled]="CertNoMovi"><!--(click)="saldocaptotalgeneral()"-->
                <b style="color: black;">Saldo Capital Total</b>
              </button>
              <button class="nav-link" id="nav-salven-tab-fichaind" data-bs-toggle="tab" data-bs-target="#nav-salven-fichaind" type="button" role="tab" aria-controls="nav-salven-fichaind" aria-selected="false" [disabled]="CertNoMovi"><!--(click)="saldovencidogeneral()"-->
                <b style="color: black;">Saldo Vencido</b>
              </button>
              <button class="nav-link" id="nav-numcred-tab-fichaind" data-bs-toggle="tab" data-bs-target="#nav-numcred-fichaind" type="button" role="tab" aria-controls="nav-numcred-fichaind" aria-selected="false" [disabled]="CertNoMovi"><!--(click)="numerocreditosgeneral()"-->
                <b style="color: black;">Número Créditos</b>
              </button>
              <button class="nav-link" id="nav-deptos-tab-fichaind" data-bs-toggle="tab" data-bs-target="#nav-deptos-fichaind" type="button" role="tab" aria-controls="nav-deptos-fichaind" aria-selected="false" [disabled]="CertNoMovi"><!--(click)="departamentosgeneral()"-->
                <b style="color: black;">Departamentos</b>
              </button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent" *ngIf="!VercargueFuente&&!AprobarcargueFuente&&!CertNoMovi">
            <div class="tab-pane fade show active" id="nav-salcapto-fichaind" role="tabpanel" aria-labelledby="nav-salcapto-tab-fichaind">
              <div class="accordion accordion-flush" id="accordionFlush5">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo13sct-fichaind">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo13sct-fichaind" aria-expanded="false" aria-controls="flush-tipo13sct-fichaind">
                      1. TIPO CREDITO OPCION 1 Y 3
                    </button>
                  </h2>
                  <div id="flush-tipo13sct-fichaind" class="accordion-collapse collapse show" aria-labelledby="flush-tipo13sct-fichaind" data-bs-parent="#accordionFlush5">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaSaldoCapitalTotalTipoCred13-fichaind" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila1 of TablaTipCred13SCTI">
                              <td scope="col" style="text-align: end;" >{{Fila1.concepto}}</td>
                              <td scope="col">{{Fila1.trimestreanterior  | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila1.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila1.variaciontrimestre}}</td>
                              <td scope="col">{{Fila1.anioanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila1.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila1.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo1sct-fichaind">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo1sct-fichaind" aria-expanded="false" aria-controls="flush-tipo1sct-fichaind">
                      2. TIPO CREDITO OPCION 1
                    </button>
                  </h2>
                  <div id="flush-tipo1sct-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo1sct-fichaind" data-bs-parent="#accordionFlush5">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaSaldoCapitalTotalTipoCred1-fichaind" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila2 of TablaTipCred1SCTI">
                              <td scope="col" style="text-align: end;">{{Fila2.concepto}}</td>
                              <td scope="col">{{Fila2.trimestreanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila2.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila2.variaciontrimestre}}</td>
                              <td scope="col">{{Fila2.anioanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila2.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila2.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo3sct-fichaind">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo3sct-fichaind" aria-expanded="false" aria-controls="flush-tipo3sct-fichaind">
                      3. TIPO CREDITO OPCION 3
                    </button>
                  </h2>
                  <div id="flush-tipo3sct-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo3sct-fichaind" data-bs-parent="#accordionFlush5">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaSaldoCapitalTotalTipoCred3-fichaind" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila3 of TablaTipCred3SCTI">
                              <td scope="col" style="text-align: end;">{{Fila3.concepto}}</td>
                              <td scope="col">{{Fila3.trimestreanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila3.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila3.variaciontrimestre}}</td>
                              <td scope="col">{{Fila3.anioanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila3.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila3.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="nav-salven-fichaind" role="tabpanel" aria-labelledby="nav-salven-tab-fichaind">
              <div class="accordion accordion-flush" id="accordionFlush6">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo13sv-fichaind">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo13sv-fichaind" aria-expanded="false" aria-controls="flush-tipo13sv-fichaind">
                      1. TIPO CREDITO OPCION 1 Y 3
                    </button>
                  </h2>
                  <div id="flush-tipo13sv-fichaind" class="accordion-collapse collapse show" aria-labelledby="flush-tipo13sv-fichaind" data-bs-parent="#accordionFlush6">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaSaldoVencidoTipoCred13-fichaind" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila4 of TablaTipCred13SVI">
                              <td scope="col" style="text-align: end;">{{Fila4.concepto}}</td>
                              <td scope="col">{{Fila4.trimestreanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila4.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila4.variaciontrimestre}}</td>
                              <td scope="col">{{Fila4.anioanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila4.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila4.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo1sv-fichaind">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo1sv-fichaind" aria-expanded="false" aria-controls="flush-tipo1sv-fichaind">
                      2. TIPO CREDITO OPCION 1
                    </button>
                  </h2>
                  <div id="flush-tipo1sv-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo1sv-fichaind" data-bs-parent="#accordionFlush6">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaSaldoVencidoTipoCred1-fichaind" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila5 of TablaTipCred1SVI">
                              <td scope="col" style="text-align: end;">{{Fila5.concepto}}</td>
                              <td scope="col">{{Fila5.trimestreanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila5.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila5.variaciontrimestre}}</td>
                              <td scope="col">{{Fila5.anioanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila5.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila5.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo3sv-fichaind">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo3sv-fichaind" aria-expanded="false" aria-controls="flush-tipo3sv-fichaind">
                      3. TIPO CREDITO OPCION 3
                    </button>
                  </h2>
                  <div id="flush-tipo3sv-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo3sv-fichaind" data-bs-parent="#accordionFlush6">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaSaldoVencidoTipoCred3-fichaind" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila6 of TablaTipCred3SVI">
                              <td scope="col" style="text-align: end;">{{Fila6.concepto}}</td>
                              <td scope="col">{{Fila6.trimestreanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila6.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila6.variaciontrimestre}}</td>
                              <td scope="col">{{Fila6.anioanterior | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila6.trimestreactual | currency: 'USD' | lowercase }}</td>
                              <td scope="col">{{Fila6.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="nav-numcred-fichaind" role="tabpanel" aria-labelledby="nav-numcred-tab-fichaind">
              <div class="accordion accordion-flush" id="accordionFlush7">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo13nc-fichaind">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo13nc-fichaind" aria-expanded="false" aria-controls="flush-tipo13nc-fichaind">
                      1. TIPO CREDITO OPCION 1 Y 3
                    </button>
                  </h2>
                  <div id="flush-tipo13nc-fichaind" class="accordion-collapse collapse show" aria-labelledby="flush-tipo13nc-fichaind" data-bs-parent="#accordionFlush7">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaNumCredTipoCred13-fichaind" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila7 of TablaTipCred13NCI">
                              <td scope="col" style="text-align: end;">{{Fila7.concepto}}</td>
                              <td scope="col">{{Fila7.trimestreanterior}}</td>
                              <td scope="col">{{Fila7.trimestreactual}}</td>
                              <td scope="col">{{Fila7.variaciontrimestre}}</td>
                              <td scope="col">{{Fila7.anioanterior}}</td>
                              <td scope="col">{{Fila7.trimestreactual}}</td>
                              <td scope="col">{{Fila7.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo1nc-fichaind">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo1nc-fichaind" aria-expanded="false" aria-controls="flush-tipo1nc-fichaind">
                      2. TIPO CREDITO OPCION 1
                    </button>
                  </h2>
                  <div id="flush-tipo1nc-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo1nc-fichaind" data-bs-parent="#accordionFlush7">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaNumCredTipoCred1-fichaind" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila8 of TablaTipCred1NCI">
                              <td scope="col" style="text-align: end;">{{Fila8.concepto}}</td>
                              <td scope="col">{{Fila8.trimestreanterior}}</td>
                              <td scope="col">{{Fila8.trimestreactual}}</td>
                              <td scope="col">{{Fila8.variaciontrimestre}}</td>
                              <td scope="col">{{Fila8.anioanterior}}</td>
                              <td scope="col">{{Fila8.trimestreactual}}</td>
                              <td scope="col">{{Fila8.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo3nc-fichaind">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo3nc-fichaind" aria-expanded="false" aria-controls="flush-tipo3nc-fichaind">
                      3. TIPO CREDITO OPCION 3
                    </button>
                  </h2>
                  <div id="flush-tipo3nc-fichaind" class="accordion-collapse collapse" aria-labelledby="flush-tipo3nc-fichaind" data-bs-parent="#accordionFlush7">
                    <div class="accordion-body">
                      <div class="container-fluid overflow-scroll" style="text-align: center;">
                        <table class="table table-bordered" id="TablaNumCredTipoCred3-fichaind" style="margin: auto;">
                          <thead style="background-color: lightgray;">
                            <tr>
                              <th scope="col" class="text-center" rowspan="2">Conceptos</th>
                              <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                              <th scope="col" class="text-center" colspan="3">Variación anual</th>
                            </tr>
                            <tr>
                              <th class="text-center">{{PeriodoCol1}}</th>
                              <th class="text-center">{{PeriodoCol2}}</th>
                              <th class="text-center">% Variación</th>
                              <th class="text-center">{{PeriodoCol4}}</th>
                              <th class="text-center">{{PeriodoCol5}}</th>
                              <th class="text-center">% Variación</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let Fila9 of TablaTipCred3NCI">
                              <td scope="col" style="text-align: end;">{{Fila9.concepto}}</td>
                              <td scope="col">{{Fila9.trimestreanterior}}</td>
                              <td scope="col">{{Fila9.trimestreactual}}</td>
                              <td scope="col">{{Fila9.variaciontrimestre}}</td>
                              <td scope="col">{{Fila9.anioanterior}}</td>
                              <td scope="col">{{Fila9.trimestreactual}}</td>
                              <td scope="col">{{Fila9.variacionanual}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="nav-deptos-fichaind" role="tabpanel" aria-labelledby="nav-deptos-tab-fichaind">
              <div class="accordion accordion-flush" id="accordionFlush8">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-tipo13depto-fichaind">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-tipo13depto-fichaind" aria-expanded="false" aria-controls="flush-tipo13depto-fichaind">
                      1. TIPO CREDITO OPCION 1 Y 3
                    </button>
                  </h2>
                  <div id="flush-tipo13depto-fichaind" class="accordion-collapse collapse show" aria-labelledby="flush-tipo13depto-fichaind" data-bs-parent="#accordionFlush8">
                    <div class="accordion-body">
                      <div style="text-align: center;">
                        <div class="container-fluid overflow-scroll" style="max-height: 450px;">
                          <table class="table table-bordered" id="TablaDeptosTipoCred13-fichaind" style="margin: auto;">
                            <thead style="background-color: lightgray;">
                              <tr>
                                <th scope="col" class="text-center" rowspan="2">Departamento</th>
                                <th scope="col" class="text-center" colspan="3">Variación trimestral</th>
                                <th scope="col" class="text-center" colspan="3">Variación anual</th>
                              </tr>
                              <tr>
                                <th class="text-center">{{PeriodoCol1}}</th>
                                <th class="text-center">{{PeriodoCol2}}</th>
                                <th class="text-center">% Variación</th>
                                <th class="text-center">{{PeriodoCol4}}</th>
                                <th class="text-center">{{PeriodoCol5}}</th>
                                <th class="text-center">% Variación</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let Fila10 of TablaTipCred13DI">
                                <td scope="col" style="text-align: end; max-width: 400px;">{{Fila10.concepto}}</td>
                                <td scope="col">{{Fila10.trimestreanterior | currency: 'USD' | lowercase }}</td>
                                <td scope="col">{{Fila10.trimestreactual | currency: 'USD' | lowercase }}</td>
                                <td scope="col">{{Fila10.variaciontrimestre}}</td>
                                <td scope="col">{{Fila10.anioanterior | currency: 'USD' | lowercase }}</td>
                                <td scope="col">{{Fila10.trimestreactual | currency: 'USD' | lowercase }}</td>
                                <td scope="col">{{Fila10.variacionanual}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="CertNoMovi">
            <br>
            <br>
          </div>
          <div *ngIf="VercargueFuente" style="text-align: center;">
            <div class="overflow-scroll" style="max-width: auto; max-height: 600px;">
              <div class="row">
                <button type="button" class="btn btn-outline-success col-1" style="margin-left: 20px;margin-bottom: 5px;" (click)="Descargar()">
                  <i class='fas fa-file-excel fa-lg'></i> Excel
                </button>
                <br>
                <table class="table table-bordered" id="TablaDeptosTipoCred13-fichaind" style="margin: auto;">
                  <thead style="background-color: lightgray;">
                    <tr>
                      <th class="text-center">Consecutivo</th>
                      <th class="text-center">Anio</th>
                      <th class="text-center">Trimestre</th>
                      <th class="text-center">Tipo de Crédito</th>
                      <th class="text-center">Departamento</th>
                      <th class="text-center">Municipio</th>
                      <th class="text-center">Solución de Vivienda</th>
                      <th class="text-center">Tenedor</th>
                      <th class="text-center">Moneda</th>
                      <th class="text-center">Rango de Vivienda</th>
                      <th class="text-center">Mora</th>
                      <th class="text-center">Número de Créditos</th>
                      <th class="text-center">Saldo Capital Total</th>
                      <th class="text-center">Capital una o mas cuotas vencidas</th>
                      <th class="text-center">Tasa</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let R of ResultadoConsulta">
                      <td scope="col" style="text-align: center;">{{R.consecutivo}}</td>
                      <td scope="col" style="text-align: center;">{{R.anio}}</td>
                      <td scope="col" style="text-align: center;">{{R.trimestre}}</td>
                      <td scope="col" style="text-align: center;">{{R.tipo_de_credito}}</td>
                      <td scope="col" style="text-align: center;">{{R.departamento}}</td>
                      <td scope="col" style="text-align: center;">{{R.municipio}}</td>
                      <td scope="col" style="text-align: center;">{{R.solucion_vivienda}}</td>
                      <td scope="col" style="text-align: center;">{{R.tenedor}}</td>
                      <td scope="col" style="text-align: center;">{{R.moneda}}</td>
                      <td scope="col" style="text-align: center;">{{R.rango_vivienda}}</td>
                      <td scope="col" style="text-align: center;">{{R.mora}}</td>
                      <td scope="col" style="text-align: center;">{{R.numero_creditos}}</td>
                      <td scope="col" style="text-align: center;">{{R.saldo_capital_total}}</td>
                      <td scope="col" style="text-align: center;">{{R.capital_una_mas_cuotas_vencidad}}</td>
                      <td scope="col" style="text-align: center;">{{R.tasa}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div *ngIf="AprobarcargueFuente">
            <div class="card">
              <div class="row" style="margin-top: 3px; margin-left: 10px;">
                <b>Observaciones para aprobar el cargue de información</b>
              </div>
              <br>
              <div style="text-align: center;">
                <textarea class="form-control col-10" name="observacionaprobador" rows="4" maxlength="255" style="margin: auto;" [(ngModel)]="EstadoInfomacionFuente.observacionSis"></textarea>
                <button type="button" class="btn btn-secondary col-auto" style="text-align: center; margin: 10px;" (click)="GuardarAprobacion()" [disabled]="BtnAprobar">Aprobar</button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Salir</button>
      </div>
    </div>
  </div>
</div>


<!--Modal Cargando-->
<button class="btn btn-primary btn-sm" #openmodalcargando data-toggle="modal"  data-target="#modal-cargando" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-md" id="modal-cargando" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-body">
        <div class="card-body container-fluid">
          <br>
          <div class="row">
            <div class="col-auto" style="margin: auto;">
              <h5>Cargando, espere un momento...</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closemodacargando style="visibility: hidden;">
                <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
              </button>
            </div>
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-danger" role="status" style="width: 60px; height: 60px;">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>
</div>


